import React from 'react';

/**
 * Komponente zum Gruppieren von Radio-Buttons mit Validierung
 */
const RadioButtonGroup = ({ isValid = true, showValidationError = false, name, children }) => {
    const validationClass = (!isValid && showValidationError) ? 'radio-group-invalid' : '';
    
    return (
        <div className={`radio-button-group ${validationClass}`} data-radio-group={name}>
            {!isValid && showValidationError && (
                <div className="invalid-feedback d-block mb-2">
                    Bitte wählen Sie eine Option aus
                </div>
            )}
            {children}
        </div>
    );
};

export default RadioButtonGroup;
